/* Book Bob page: sliders (arrows + dots share the same stops), quote buttons, thank you scroll.
   Loaded by templates/page.book-bob.liquid. */
(function () {
  var root = document.getElementById('bookBob');
  if (!root) return;

  // Sliders: the photo strip has three stops (start, middle, end); the review strip stops on each review.
  // Arrows step between stops, dots jump to a stop, and the active dot follows the scroll.
  function makeSlider(strip) {
    var wrap = root.querySelector('.dots[data-dots="' + strip.id + '"]');
    var dots = wrap ? wrap.querySelectorAll('button') : [];
    var bySlide = strip.classList.contains('rev-strip');
    function stops() {
      var list = [];
      if (bySlide) {
        for (var c = 0; c < strip.children.length; c++) list.push(strip.children[c].offsetLeft - strip.offsetLeft);
      } else {
        var max = Math.max(0, strip.scrollWidth - strip.clientWidth);
        var n = Math.max(2, dots.length);
        for (var k = 0; k < n; k++) list.push(Math.round(k * max / (n - 1)));
      }
      return list;
    }
    function current() {
      var list = stops(), best = Infinity, idx = 0;
      for (var i = 0; i < list.length; i++) {
        var d = Math.abs(list[i] - strip.scrollLeft);
        if (d < best) { best = d; idx = i; }
      }
      return idx;
    }
    function goTo(i) {
      var list = stops();
      i = Math.max(0, Math.min(list.length - 1, i));
      strip.scrollTo({ left: list[i], behavior: 'smooth' });
    }
    function paint() {
      var idx = current();
      for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-on', k === idx);
    }
    var arrows = root.querySelectorAll('.arrow[data-strip="' + strip.id + '"]');
    for (var a = 0; a < arrows.length; a++) {
      arrows[a].addEventListener('click', function () {
        goTo(current() + (parseInt(this.getAttribute('data-dir'), 10) || 1));
      });
    }
    for (var b = 0; b < dots.length; b++) {
      dots[b].addEventListener('click', function () { goTo(parseInt(this.getAttribute('data-page'), 10)); });
    }
    strip.addEventListener('scroll', paint, { passive: true });
    paint();
  }
  var strips = root.querySelectorAll('.strip');
  for (var s = 0; s < strips.length; s++) makeSlider(strips[s]);

  // Quote buttons: preselect the interest and remember the package
  var interest = document.getElementById('bkInterest');
  var pkg = document.getElementById('bkPackage');
  var message = document.getElementById('bkMessage');
  var links = root.querySelectorAll('a[href="#book"]');
  for (var j = 0; j < links.length; j++) {
    links[j].addEventListener('click', function () {
      var want = this.getAttribute('data-interest') || '';
      var name = this.getAttribute('data-package') || '';
      if (want && interest) interest.value = want;
      if (pkg) pkg.value = name;
      if (name && message && !message.value) {
        message.value = 'Interested in: ' + name + '. ';
      }
    });
  }

  // After a successful send Shopify comes back with contact_posted=true
  if (window.location.search.indexOf('contact_posted=true') > -1) {
    var ok = document.getElementById('bookOk');
    if (ok) {
      setTimeout(function () { ok.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 150);
    }
  }
})();
